import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="5"
          height="7"
          fill="none"
          viewBox="0 0 5 7"
        >
          <path
            fill="#898F9E"
            stroke="#898F9E"
            strokeWidth="0.1"
            d="M1.06 5.948a.338.338 0 010-.5l1.898-1.771a.238.238 0 000-.354L1.06 1.551a.338.338 0 010-.5.39.39 0 01.525 0l-.034.037.034-.036L3.94 3.25a.338.338 0 010 .5L1.585 5.948a.39.39 0 01-.525 0zm0 0l.035-.036-.035.036z"
          ></path>
        </svg>
    );
}